import { cn } from '@workspace/ui/lib/utils';
import { times } from 'lodash-es';

import { StarIcon } from '~/pages/Product/Citydrinks/ProductV3/components/StarIcon';

import type { StarRatingProps } from '../../interfaces';

import styles from './StarRating.module.scss';

const StarRating = ({ rating, size = 16, className }: StarRatingProps) => {
  return (
    <div className={cn(styles.root, className)}>
      {times(5, (idx) => {
        const fillPercentage = Math.min(Math.max(rating - idx, 0), 1) * 100;
        const isFull = fillPercentage === 100;
        const isEmpty = fillPercentage === 0;
        const isPartial = !isFull && !isEmpty;

        return (
          <div key={idx} className={styles.starWrapper}>
            {isPartial ? (
              <>
                <StarIcon size={size} className={styles.starEmpty} />
                <div
                  className={styles.starFilled}
                  style={{ width: `${fillPercentage}%` }}
                >
                  <StarIcon size={size} className={styles.starIcon} />
                </div>
              </>
            ) : (
              <StarIcon
                size={size}
                className={isFull ? styles.starIcon : styles.starEmpty}
              />
            )}
          </div>
        );
      })}
    </div>
  );
};

export default StarRating;
